import { Box, Button, Container, Divider, Paper, Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { sendVerification, findUserName, forgotPassword } from '../../../api/verification';
import { useToast } from 'use-toast-mui';
import { errorMessages } from '../../../utils/methods';
import ForgotTab2 from './ForgotTab2';
import EmailResponsePassword from './email-response-password';
import { useState } from 'react';

const Password = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const toast = useToast();
  const [next, setNext] = useState(true);
  const [tab, setTab] = useState(1);
  const [data, setData] = useState({
    email: null,
    verificationCode: null,
    username: null,
    password: null,
  });

  // Verifying the entered code
  const verifyEnteredCode = async () => {
    if (tab === 1) {
      const { email, verificationCode } = data;

      if (email && verificationCode) {
        try {
          const response = await findUserName({ email, verificationCode });
          if (response) {
            toast.success('인증번호가 확인되었습니다');
            setData({ ...data, username: response.username });
            setTab(2);
          } else {
            toast.error('인증번호가 맞지 않습니다. 다시 입력해주세요');
          }
        } catch (error) {
          if (error.response.status === 404) toast.error("인증 번호가 올바르지 않습니다");
        }
      }
    } else {
      const { email, verificationCode, password } = data;

      if (email && verificationCode && password) {
        try {
          const response = await forgotPassword({ email, verificationCode, password });
          if (response) {
            toast.success('비밀 번호 성공적으로 변경 됐습니다');
            // setData({ ...data, username: response.username });
            navigate('/login');
          } else {
            toast.error('비밀 번호 변경이 실패 했습니다. 다시 시도 하시기를  바랍니다');
          }
        } catch (error) {
          toast.error(errorMessages(error));
        }
      }
    }
  };

  return (
    <Box sx={{ mt: 6, ml: 7 }}>
      <img src="/images/logo/logoo.svg" alt="logo" />
      <Container maxWidth="lg" sx={{ mt: 13.5 }}>
        <Paper
          sx={{
            color: theme.palette.info.main,
            boxShadow: '0px 0px 7px #0000001A',
            borderRadius: '10px',
            elevation: 3,
            py: 6,
            px: 7.5,
          }}>
          <Typography sx={{ fontSize: '30px', lineHeight: '34px', fontWeight: 'bold' }}>비밀번호 찾기</Typography>
          <Divider sx={{ border: '1px solid #E7E7E7', mt: 5.2, mb: 3 }} />
          {tab === 1 ? (
            <ForgotTab2 setNext={setNext} setData={setData} />
          ) : (
            <EmailResponsePassword data={data} setData={setData} setNext={setNext} />
          )}
          <Divider sx={{ border: '1px solid #E7E7E7', mt: 5.2, mb: 3 }} />
          <Stack sx={{ flexDirection: 'row', justifyContent: 'end' }}>
            <Button
              variant="contained"
              color="secondary"
              sx={{
                color: '#fff',
                borderRadius: '5px',
                height: 40,
                minWidth: 125,
                boxShadow: 'none',
                mr: 1,
              }}
              onClick={() => (tab === 2 ? setTab(1) : navigate('/login'))}>
              뒤로가기
            </Button>
            <Button
              disabled={next}
              variant="contained"
              color="primary"
              sx={{ borderRadius: '5px', minWidth: 183 }}
              onClick={() => {
                verifyEnteredCode();
              }}>
              {tab === 2 ? '확인' : '비밀번호 확인'}
            </Button>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default Password;
